import Axios from "../../../services/axios";

export default function DownloadCommissionDetail({
  id,
  periodStart,
  periodEnd,
  resellerStatus,
  Trigger
}) {
  async function handleDownload() {
    const response = await Axios({
      url: `/admin/commission/detail/${id}/download`,
      params: {
        ...(!!resellerStatus && { resellerStatus }),
        ...(!!periodStart && { periodStart }),
        ...(!!periodEnd && { periodEnd }),
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      },
      responseType: "blob",
    });

    const blob = new Blob([response.data], { 
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    const filename = [`commission-detail-${id}`];
    if (resellerStatus) filename.push(resellerStatus);
    if (periodStart) filename.push(periodStart);
    if (periodEnd) filename.push(periodEnd);
    
    link.download = `${filename.join("_")}.xlsx`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return <>{Trigger({ onClick: handleDownload })}</>;
}